"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zM16.5 19a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.013 1.385A.5.5 0 0120.5 1h3a.5.5 0 010 1h-2.604l-3.91 16.614A.5.5 0 0116.5 19h-11a.5.5 0 010-1h10.604l3.91-16.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.594 7.208A.5.5 0 011 7h18.1a.5.5 0 010 1H1.694l2.666 8H17a.5.5 0 010 1H4a.5.5 0 01-.474-.342l-3-9a.5.5 0 01.068-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.646 3.146a.5.5 0 01.703-.004l4.1 4a.5.5 0 01-.698.716l-3.747-3.655-3.65 3.65a.5.5 0 01-.708-.707L12.793 5H10v2.5a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5h4.293l.853-.854zM3.172.33a.5.5 0 01.284.266l3 6.7a.5.5 0 01-.912.408l-2.79-6.231-1.596.766 2.297 5.054a.5.5 0 11-.91.414l-2.5-5.5a.5.5 0 01.239-.658l2.5-1.2a.5.5 0 01.388-.018z"
  }));
}

var _default = SvgPurchase;
exports["default"] = _default;